import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import {   injectIntl } from "react-intl";


import {   TextField } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { updateMaster} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";

import 'date-fns';
 

function EditProcedure(props) {
  
  console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 // const [user,setUser] =useState({});

  
  
 const [procedureType,setProcedureType] =useState(props.location.data.procedureType);

 const [val,setVal]=useState(false);


  const [statusColor, setStatusColor] = useState('alert-success');

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };




  return (

      <Formik
                  initialValues={{
                    procedureTypeName: procedureType.procedureTypeName,
                    typeDescription: procedureType.typeDescription,
                    
                    
                  }}
                  validate={values => {
                    const errors = {};

                    
                    if (!values.procedureTypeName) {
                      errors.procedureTypeName = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.typeDescription) {
                      errors.typeDescription = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    
                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                    enableLoading();

                    let data  = {
                      'procedureTypeName' : values.procedureTypeName,
                      'typeDescription': values.typeDescription
                      

                    }


                    updateMaster('proceduretype',procedureType.procedureTypeKey,data)
                      .then(resp => {
                        //props.register(accessToken);
                       
                        disableLoading();
                        setStatus(
                          intl.formatMessage({
                            id: "CREATION.SUCCESS.MESSAGE"
                          })
                        );
                        setStatusColor('alert-success');
                        window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        disableLoading();
                        setSubmitting(false);
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                        setStatusColor('alert-danger');
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

    <CodeExample beforeCodeTitle="Basic Details">
          <div className="kt-section">
            <div className="kt-section__content">


                  <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Tier"
                          className="kt-width-full"
                          name="procedureTypeName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.procedureTypeName}
                          helperText={touched.procedureTypeName && errors.procedureTypeName}
                          error={Boolean(touched.procedureTypeName && errors.procedureTypeName)}
                        />
                      </div>    

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          name="typeDescription"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.typeDescription}
                          helperText={touched.typeDescription && errors.typeDescription}
                          error={Boolean(touched.typeDescription && errors.typeDescription)}
                        />
                      </div> 

                      
                 
        </div>
        </div>
        </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Update
                        </button>
                      </div>
        </form>
         )}
                </Formik>
                
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(EditProcedure)
);
